<template>
  <div>
    <el-form ref="form" :model="formData" size="small" :rules="rules">
      <el-row>
        <el-form-item
          :label="$l('form_label_isCustomer') || '是否客户提供文档'"
          prop="isCustomer"
        >
          <el-radio-group v-model="formData.isCustomer">
            <el-radio :label="'Y'">{{ $l('INDEX.YES') || '是' }}</el-radio>
            <el-radio :label="'N'">{{ $l('INDEX.NO') || '否' }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          :label="$l('form_label_fileRemark') || '备注说明'"
          prop="remark"
        >
          <el-input
            v-model="formData.remark"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            type="textarea"
            :maxlength="50"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-row>
      <el-row class="mt-2">
        <el-upload
          drag
          action="#"
          :file-list="listFile"
          :auto-upload="false"
          :limit="uploadLimit"
          :on-exceed="onFileExceed"
          :on-change="onFileChange"
          :on-remove="onFileChange"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
            }}<em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
          </div>
        </el-upload>
      </el-row>
    </el-form>

    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      append-to-body
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="upload()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'

export default {
  mixins: [EditLoading],
  props: {
    uploadLimit: { type: Number, default: 1 },
    expoMeetingCode: { type: String, default: '' },
    tskInfoCode: { type: String, default: '' },
    tskRemarkCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: { remark: '', isCustomer: '' },
      listFile: [],
      localTimeZone: '',
      loading: false,
      backDialogVisible: false,
      rules: {
        remark: [
          {
            required: true,
            message: this.$l('tips_remark') || '请输入备注说明',
            trigger: 'blur',
          },
        ],
        isCustomer: [
          {
            required: true,
            message: this.$l('tips_isCustomer') || '请选择是否客户提供文档',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('admin/upload', ['push']),
    onFileChange(files, fileList) {
      this.listFile = fileList
    },
    onFileExceed(files, fileList) {
      this.listFile = fileList
      // this.$message.warning(
      //   `当前限制选择 ${this.uploadLimit} 个文件，本次选择了 ${
      //     files.length
      //   } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      // )
    },
    async upload() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        this.backDialogVisible = false
        return false
      }
      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message: '请选择文档',
          type: 'warning',
        })
        this.backDialogVisible = false
        return false
      }
      this.loadingOpen()
      const listDoc = await this.uploadFiles()
      this.backDialogVisible = false
      this.loadingClose()
      if (!listDoc || !listDoc.length) {
        this.$message({
          message: '上传失败',
          type: 'warning',
        })
        return false
      }

      if (listDoc.length !== listDoc.filter(Boolean).length) {
        this.$message({
          message: '上传失败',
          type: 'warning',
        })
        return false
      }

      const localTimeZone = await this.loadLocalTimeZone()
      const params = {
        listDoc,
        expoMeetingCode: this.expoMeetingCode,
        tskInfoCode: this.tskInfoCode,
        tskRemarkCode: this.tskRemarkCode,
        timeZone: localTimeZone,
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .expoTskInfoDocUploadApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.$emit('close')
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    uploadFiles() {
      if (!this.listFile || !this.listFile.length) {
        return Promise.resolve([])
      }

      const { remark, isCustomer } = this.formData
      const files = this.listFile.map(({ name: fileName, raw }) => ({
        fileName,
        raw,
        remark,
        isCustomer,
      }))
      const uploadTask = files.map((file) => {
        return new Promise((resolve) => {
          this.push({
            file: file.raw,
            added: ({ md5, suffix }) => {
              const fileCode = [md5, suffix].filter(Boolean).join('.')
              resolve({
                fileCode,
                fileSize: this.formatFileSize(file.raw.size),
                fileName: file.fileName,
                remark: file.remark,
                isCustomer: file.isCustomer,
              })
            },
            fail: () => resolve(null),
          })
        })
      })
      return Promise.all(uploadTask)
    },
    formatFileSize(bytes) {
      console.log(bytes)
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + 'MB'
      } else if (bytes >= 1024) {
        return (bytes / 1024).toFixed(2) + 'KB'
      } else {
        return bytes + 'B'
      }
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
